import {
   // actions
    SET_PROPS
   // reducer names
   ,ITEM_EDITOR
} from '../constants'

export const close = () => (
    {
        type: ITEM_EDITOR + SET_PROPS,
        payload: {
            value: { open: false }
        }
    }
);
